import dayjs from 'dayjs'
import qs from 'qs'
import { useSearchParams } from 'react-router-dom'
import type { AllFilters } from '../utils/dashboardFilters'

const useToDosFilterParams = (initialFiltersValue: AllFilters) => {
  const initialString = transformAllFiltersToString(initialFiltersValue)

  const [params, setParams] = useSearchParams(initialString)

  const filterParams = transformStringToAllFilters(params.toString())

  const setQueryParamsState = (
    getState: (prevState: AllFilters) => AllFilters
  ) => {
    const newState = getState(filterParams)
    const newQueryParams = transformAllFiltersToString(newState)

    setParams(newQueryParams)
  }

  return [filterParams, setQueryParamsState] as const
}

const transformAllFiltersToString = (params: AllFilters): string => {
  const rangePicker = params?.rangePicker?.map((date) =>
    date?.toISOString?.()
  ) as AllFilters['rangePicker']

  const newQueryString = qs.stringify({
    ...params,
    rangePicker
  })

  return newQueryString
}

export const transformStringToAllFilters = (
  queryParams: string
): AllFilters => {
  const newFilterParams =
    (qs.parse(queryParams) as Omit<AllFilters, 'rangePicker'> & {
      rangePicker: [string | null, string | null] | undefined | null
    }) || {}

  if (newFilterParams?.rangePicker) {
    ;(newFilterParams.rangePicker as AllFilters['rangePicker']) =
      newFilterParams.rangePicker?.map((dateString) =>
        dayjs(dateString)
      ) as AllFilters['rangePicker']
  }

  return newFilterParams as AllFilters
}

export default useToDosFilterParams
